import useLanguage from '../hooks/useLanguage';

import styles from '../assets/styles/DeviceMobile.module.css';
import { translations } from '../locales/lang';

export default function DeviceMobile() {
    const { language } = useLanguage();
    return (
        <>
            <div className={styles.containerTitle}>
                <h2 className={styles.title}>{translations[language].device.title}</h2>
                <p className={styles.subtitle}>
                    {translations[language].device.desc}
                </p>
            </div>

            <div className={styles.container}>
                <div className={styles.columnLeft}>
                    <div className={styles.containerInfo} >
                        <h3 className={styles.columnTitle} data-aos="fade-right">{translations[language].device.web.title}</h3>
                        <div className={styles.containerContent}>
                            <div className={styles.columnContent}>
                                <p className={styles.description} data-aos="fade-right" dangerouslySetInnerHTML={{ __html: translations[language].device.web.desc }} />
                                <ul className={styles.featureList} data-aos="fade-right">
                                    <li>{translations[language].device.web.features[0]}</li>
                                    <li>{translations[language].device.web.features[1]}</li>
                                    <li>{translations[language].device.web.features[2]}</li>
                                </ul>
                            </div>
                            <img src='/images/device/laptop.png' alt="Device" className={styles.laptop} data-aos="fade" />
                        </div>
                    </div>

                </div>
                <div className={styles.columnRight}>
                    <div className={styles.containerInfo}>
                        <h3 className={styles.columnTitle} data-aos="fade-left">{translations[language].device.mobile.title}</h3>
                        <div className={styles.containerContent}>
                            <div className={styles.columnContent}>
                                <p className={styles.description} data-aos="fade-left" dangerouslySetInnerHTML={{ __html: translations[language].device.mobile.desc }} />
                                <ul className={styles.featureList} data-aos="fade-left">
                                    <li>{translations[language].device.mobile.features[0]}</li>
                                    <li>{translations[language].device.mobile.features[1]}</li>
                                    <li>{translations[language].device.mobile.features[2]}</li>
                                </ul>
                            </div>
                            <img src='/images/device/phone.png' alt="Device" className={styles.phone} data-aos="fade" />
                        </div>
                    </div>
                    <div className={styles.stores} data-aos="fade-left">
                        <div className={styles.qrCode}>
                            <img src="/images/device/qr-code.png" alt="qr-code" style={{ width: '93px', height: 'auto', objectFit: 'contain' }} />
                        </div>
                        <div className={styles.storesList}>
                            <img src="/images/device/app-store.png"
                                alt="App Store"
                                style={{ cursor: 'pointer' }}
                                onClick={() => { window.open("https://apps.apple.com/id/app/lcms-i-school/id6747659818", "_blank") }} />
                            <img src="/images/device/ch-play.png"
                                alt="Google Play"
                                style={{ cursor: 'pointer' }}
                                onClick={() => { window.open("https://play.google.com/store/apps/details?id=com.dtp.ischool&hl=en", "_blank") }} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
